export { default } from './ExternalShareContentRendererLoader.ts';
